import { DevOpsAction } from '../models/DevOpsAction';

export class GetDevOpsActionsResponse {
    eventRules?: DevOpsAction[];
    error?: string;
}